<template>
    <div class="content_div">
        <el-card>
            <!--商品-->
            <el-form :inline="true" :model="query" class="demo-form-inline" STYLE="margin-bottom: 20px;">
                <el-form-item label="姓名" clearable>
                    <el-input class="input_class" v-model="query.nickName" auto-complete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" clearable>
                    <el-input class="input_class" v-model="query.nickName" auto-complete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                <el-button type="success" @click="btnInsert(null,0)">新增</el-button>
            </el-form>

            <el-table
                :data="dataList"
                border>
                <el-table-column type="index" label="编号" width="80"/>
                <el-table-column prop="username" label="登陆名" width="200"/>
                <el-table-column prop="phone" label="手机号" width="200"/>
                <el-table-column prop="nickname" label="姓名" width="200"/>

                <el-table-column prop="nickname" label="负责店铺">
                    <template slot-scope="scope">
                        <span v-for="item in scope.row.shopList">{{ item.name }};</span>
                    </template>
                </el-table-column>

                <el-table-column prop="createTime" label="创建时间" width="160"/>
                <el-table-column align="center" label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" @click="btnAuth(scope.row)">分配</el-button>
                        <el-button size="small" type="success" @click="btnReset(scope.row)">重置密码</el-button>
                        <el-button size="small" type="info" @click="btnInsert(scope.row,2)">修改</el-button>
                        <el-button size="small" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top:10px;"
                           background
                           layout="total,prev, pager, next"
                           @current-change="currentChange"
                           :total="total">
            </el-pagination>

        </el-card>

        <el-dialog :close-on-click-modal="false" title="操作" :visible="isShowDialogFlag" @close="close" width="30%">
            <el-form label-width="120px" :model="data" ref="data" :rules="rules">
                <el-form-item label="登陆名" prop="username">
                    <el-input maxLength="20" v-model="data.username" maxlength="20" auto-complete="off" placeholder="请输入登陆名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input maxlength="11" v-model="data.phone" auto-complete="off" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="nickname">
                    <el-input maxlength="20" v-model="data.nickname" auto-complete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click='close'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 角色分配对话框 -->
        <el-dialog :close-on-click-modal="false" title="分配角色" :visible="authDialog" @close="closeAuthDialog" width="40%">
            <el-form :model="authParams" ref="roleForm" label-width="100px">
                <el-form-item label="姓名">
                    <el-input v-model="authParams.nickname" disabled></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="authParams.phone" disabled></el-input>
                </el-form-item>
                <el-form-item label="店铺列表" prop="roleIdList">
                    <el-select v-model="authParams.idList" multiple placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="item in shopList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">{{ item.name }}
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeAuthDialog">取消</el-button>
                <el-button type="primary" @click="submitRoleForm">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import global from "@/api/global";
import {reqDeleteSysUsersById, reqInsertSysUsers, reqListSysUsers, reqUpdateSysUsers} from "@/api/core/Person";
import user from "@/store/modules/user";
import {reqListShop} from "@/api/core/Shop";
import {reqAuthEmployeeShop} from "@/api/core/Users";
import {resetPassword} from "../../../api/user";

const userType = 2;
export default {
    name: "User",
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            this.dataList = [];
            let data = await reqListSysUsers(this.query);
            this.dataList = data.records;
            this.total = data.total;
        },
        btnInsert(row, type) {
            if (type === 0) {
                this.data = {};
            } else if (type === 1) {
                this.data = {};
            } else {
                this.data = JSON.parse(JSON.stringify(row));
            }
            this.isShowDialogFlag = true;
        },

        async close() {
            this.isShowDialogFlag = false;
        },
        async btnReset(row){
            const that = this
            this.$confirm('是否重置用户 ' + row.nickname + ' 的密码？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 执行重置用户密码方法
                resetPassword(row.id).then((res) => {
                    that.$message.success('密码重置成功')
                })
            }).catch(() => {
            })
        },
        currentChange(num) {
            this.query.currentPage = num;
            this.load();
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    this.data.type = userType;
                    let result = !this.data.id ? await reqInsertSysUsers(this.data) : await reqUpdateSysUsers(this.data);
                    this.$message.success("操作成功");
                    await this.close();
                    await this.load();
                }
            })
        },
        async btnDelete(id) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqDeleteSysUsersById({id: id});
                this.$message.success("操作成功");
                this.query.currentPage = 1
                await this.load();
            });
        },
        async btnAuth(row) {
            this.authParams.nickname = row.nickname;
            this.authParams.phone = row.phone;
            this.authParams.userId = row.id;
            this.authParams.idList = row.shopIdList;
            //获取店铺列表
            let data = await reqListShop({});
            this.shopList = data;
            this.authDialog = true;
        },
        closeAuthDialog() {
            this.authDialog = false;
        },
        /**
         * 提交角色分配表单
         */
        async submitRoleForm() {
            if (this.authParams.idList.length === 0) {
                this.$message.error("请选择店铺");
                return;
            }
            await reqAuthEmployeeShop(this.authParams);
            this.$message.success("店铺分配成功");
            this.closeAuthDialog();
            await this.load();
        },

    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {
                currentPage: 1,
                pageSize: 10,
                type: userType,
            },
            isShowDialogFlag: false,
            filePre: global.preview_path_url,
            data: {
                id: null,
            },
            rules: {
                username: [
                    {required: true, message: '请输入用户名', trigger: 'blur'},
                ],
                nickname: [
                    {required: true, message: '请输入昵称', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                ]
            },
            currentLoginUserType: user.state.type,
            authDialog: false,
            authParams: {
                userId: null,
                idList: [],
            },
            shopList: [],
        }
    },
}
</script>
